import { Grid, TextField, Typography } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Paper from "@material-ui/core/Paper";
import Slider from "@material-ui/core/Slider";
import {
  createStyles,
  makeStyles,
  Theme,
  withStyles,
} from "@material-ui/core/styles";
import SendIcon from "@material-ui/icons/Send";
import React from "react";
import { connect } from "react-redux";
import { useTextStyles } from "src/styles/textStyles";
import { useWallet } from "@solana/wallet-adapter-react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(2),
      textAlign: "center",
      color: theme.palette.text.secondary,
    },
    rowRootGrid: {
      padding: theme.spacing(2),
    },
    rowRootPaper: {
      margin: theme.spacing(2),
      textAlign: "center",
    },
    button: {
      margin: theme.spacing(1),
    },
  })
);

const PrettoSlider = withStyles({
  root: {
    color: "#52af77",
    height: 8,
  },
  thumb: {
    height: 24,
    width: 24,
    backgroundColor: "#fff",
    border: "2px solid currentColor",
    marginTop: -8,
    marginLeft: -12,
    "&:focus, &:hover, &$active": {
      boxShadow: "inherit",
    },
  },
  active: {},
  valueLabel: {
    left: "calc(-50% + 4px)",
  },
  track: {
    height: 8,
    borderRadius: 4,
  },
  rail: {
    height: 8,
    borderRadius: 4,
  },
})(Slider);

const AMC = (props) => {
  const classes = useStyles();
  const textClasses = useTextStyles();
  const { publicKey } = useWallet();

  const [investmentAmount, setInvestMentAmount]: any = React.useState(0.0);
  const [redeemAmount, setRedeemAmount]: any = React.useState(0.0);

  const sanBalance = props?.tradeInfo?.sanBalance || 0;
  const usdcBalance = props?.tradeInfo?.usdcBalance || 0;
  return (
    <Grid container direction="column">
      <Paper className={classes.rowRootPaper}>
        {publicKey ? (
          <Typography className={textClasses.subHeading}>
            Your Balance
          </Typography>
        ) : (
          <Typography className={textClasses.subHeading}>
            Connect wallet to start investing
          </Typography>
        )}

        {publicKey && (
          <Grid
            container
            item
            md={12}
            spacing={3}
            className={classes.rowRootGrid}
          >
            <Grid item xs={12} md={6}>
              <Paper className={classes.paper}>
                <Typography className={textClasses.normalTextBlack}>
                  {`USDC Balance : ${usdcBalance}`}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={12} md={6}>
              <Paper className={classes.paper}>
                <Typography className={textClasses.normalTextBlack}>
                  {`SAN (NAV) Balance : ${sanBalance}`}
                </Typography>
              </Paper>
            </Grid>
          </Grid>
        )}
      </Paper>
      <Paper className={classes.rowRootPaper}>
        <Typography className={textClasses.subHeading}>NAV Rate</Typography>
        <Typography className={textClasses.bigTextBlack}>
          {`1 SAN = 10.0000 USDC`}
        </Typography>
      </Paper>
      <Paper className={classes.rowRootPaper}>
        <Grid
          container
          item
          md={12}
          spacing={3}
          className={classes.rowRootGrid}
        >
          <Grid item xs={12} md={6}>
            <Typography className={textClasses.subHeading}>Invest</Typography>
            <Paper className={classes.paper}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                color="primary"
                className={textClasses.normalTextBlack}
                fullWidth
                value={investmentAmount}
                onChange={(event) => {
                  const inputAmountString =
                    event.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1") || "";
                  const limit = usdcBalance;
                  const actualAmountString =
                    parseFloat(inputAmountString) > limit
                      ? limit.toString()
                      : inputAmountString;
                  setInvestMentAmount(actualAmountString);
                }}
              />
              <PrettoSlider
                valueLabelDisplay="off"
                aria-label="pretto slider"
                value={investmentAmount}
                min={0}
                max={usdcBalance}
                step={0.01}
                onChange={(event, value) => {
                  setInvestMentAmount(value);
                }}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                endIcon={<SendIcon />}
              >
                Invest
              </Button>
            </Paper>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography className={textClasses.subHeading}>Redeem</Typography>
            <Paper className={classes.paper}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                color="primary"
                className={textClasses.normalTextBlack}
                fullWidth
                value={redeemAmount}
                onChange={(event) => {
                  const inputAmountString =
                    event.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*?)\..*/g, "$1") || "";
                  const limit = sanBalance;
                  const actualAmountString =
                    parseFloat(inputAmountString) > limit
                      ? limit.toString()
                      : inputAmountString;
                  setRedeemAmount(actualAmountString);
                }}
              />
              <PrettoSlider
                valueLabelDisplay="off"
                aria-label="pretto slider"
                value={redeemAmount}
                min={0}
                max={sanBalance}
                step={0.01}
                onChange={(event, value) => {
                  setRedeemAmount(value);
                }}
              />
              <Button
                variant="contained"
                color="primary"
                className={classes.button}
                endIcon={<SendIcon />}
              >
                Redeem
              </Button>
            </Paper>
          </Grid>
        </Grid>
      </Paper>
    </Grid>
  );
};

const mapStateToProps = ({ tradeInfo }) => ({
  tradeInfo: tradeInfo,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AMC);
